import api from './api';

const checkAuth = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required. Please sign in.');
  }
  return token;
};

const buildParams = (filters = {}) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    const value = filters[key];
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        value.forEach(item => params.append(key, item));
      } else {
        params.append(key, value);
      }
    }
  });
  return params.toString();
};

export const getProfitData = async (filters = {}) => {
  checkAuth();
  const query = buildParams(filters);
  const response = await api.get(`/api/data_predator/profits/${query ? `?${query}` : ''}`);
  return response.data;
};

export const createProfit = async (profitData) => {
  checkAuth();
  const response = await api.post('/api/data_predator/profits/', profitData);
  return response.data;
};

export const updateProfit = async (profitId, profitData) => {
  checkAuth();
  const response = await api.patch(`/api/data_predator/profits/${profitId}/`, profitData);
  return response.data;
};

export const deleteProfit = async (profitId) => {
  checkAuth();
  await api.delete(`/api/data_predator/profits/${profitId}/`);
  return true;
};
